import { Shield } from 'lucide-react'
import {
  pickString,
  readToolState,
  ToolStatusLine,
  type ToolPartProps,
} from './_base'

export function CisLookupToolMessage({ part }: ToolPartProps) {
  const state = readToolState(part)
  const ref = pickString(state.args?.cisRef, state.args?.controlRef)
  return (
    <ToolStatusLine
      state={state}
      loadingLabel='Looking up CIS benchmark...'
      completedLabel='CIS benchmark loaded'
      loadingDetail={ref}
      completedDetail={ref}
      completedIcon={<Shield className='h-3.5 w-3.5 shrink-0 text-text-placeholder' />}
    />
  )
}
